import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import List from '../Home/List.jsx'
import { appService } from '../../_services';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';
import ReactGA from 'react-ga';

export class ContactSalesNew extends Component {
    displayName = ContactSalesNew.name

    constructor(props) {
        super(props);
        this.childList = React.createRef();
        this.state = {
            userDetails: {
                salutation: '',
                firstName: '',
                lastName: '',
                emailAddress: '',
                phoneNumber: '',
                organization: '',
                jobTitle: '',
                iAgree: false,
                intrestedInmkting: false,
                country: '',
                subType: '',
                addInfo: '',
                redirectToThankyou: false
            },
            errors: {},
            submitted: false,
            email: '',
            valid: true,
            content: '',
            users: [],
            countries: [],
            data: [],
            selectedString: '', practicearea: '', selectedOption: '',
            Interest_Arbitration: false,
            Interest_Comparative: false,
            Interest_Competition: false,
            Interest_Corporate: false,
            Interest_Environmental: false,
            Interest_European: false,
            Interest_Intellectual: false,
            Interest_Labor: false,
            Interest_Tax: false,
            Interest_Trade: false,
            Interest_Transport: false
        };

        this.radioChange = this.radioChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.submitEnquiry = this.submitEnquiry.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.handleCountriesChange = this.handleCountriesChange.bind(this);
        this.handleSalutationChange = this.handleSalutationChange.bind(this);
        this.handlecheckChange = this.handlecheckChange.bind(this);
        this.handlemailchimpcheck = this.handlemailchimpcheck.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.myFunction = this.myFunction.bind(this);
    }



    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    valueChange(event) {
        const { name, value } = event.target;
        const { userDetails } = this.state;
        this.setState({
            userDetails: {
                ...userDetails,
                [name]: value
            }
        });
    }

    handleCountriesChange(event) {
        //let fields = this.state.fields;
        const { userDetails } = this.state;
        //fields[event.target.id] = event.target.value;
        this.setState({
            userDetails: {
                ...userDetails,
                country: event.target.value
            }
        });
        // this.setState({ [event.target.id]: event.target.value, fields });
    }

    handleSalutationChange(event) {
        const { userDetails } = this.state;
        this.setState({
            userDetails: {
                ...userDetails,
                salutation: event.target.value
            }
        });
    }

    handlecheckChange(evt) {
        const { userDetails } = this.state;
        this.setState({
            userDetails: {
                ...userDetails,
                iAgree: evt.target.checked
            }
        });
    }

    handlemailchimpcheck(evt) {
        const { userDetails } = this.state;
        this.setState({
            userDetails: {
                ...userDetails,
                intrestedInmkting: evt.target.checked
            }
        });
    }

    radioChange(e) {
        this.setState({
            selectedOption: e.currentTarget.value
        });

        const { userDetails } = this.state;

        if (e.target.checked) {
            var type = e.target.value;
            this.setState({
                userDetails: {
                    ...userDetails,
                    subType: type
                }
            });
        }

    }

    handleTypeChange(evt) {
        const { userDetails } = this.state;
        if (evt.target.checked) {
            var type = userDetails.subType == "" ? evt.target.name : userDetails.subType + ', ' + evt.target.name;
            this.setState({
                userDetails: {
                    ...userDetails,
                    subType: type
                }
            });
        }
        else {
            var type = userDetails.subType.replace(evt.target.name + ', ', '').replace(', ' + evt.target.name, '').replace(evt.target.name, '');
            this.setState({
                userDetails: {
                    ...userDetails,
                    subType: type
                }
            });
        }
        console.log(this.state.userDetails);
    }


    updateCount(UpdatedCount) {
        //console.log(UpdatedCount);
        this.setState({ selectedString: UpdatedCount.join(', ') });
    }

    GetPA(PAList) {
        //console.log(PAList);        
        this.state.Interest_Arbitration = false;
        this.state.Interest_Comparative = false;
        this.state.Interest_Competition = false;
        this.state.Interest_Corporate = false;
        this.state.Interest_Environmental = false;
        this.state.Interest_European = false;
        this.state.Interest_Intellectual = false;
        this.state.Interest_Labor = false;
        this.state.Interest_Tax = false;
        this.state.Interest_Trade = false;
        this.state.Interest_Transport = false;

        PAList.forEach(this.myFunction);
        this.setState({ practicearea: PAList.join(', ') });
    }


    myFunction(item, index) {
        if (item == "Arbitration, Litigation & Mediation") {
            this.state.Interest_Arbitration = true;
        }
        else if (item == "Comparative Law") {
            this.state.Interest_Comparative = true;
        }
        else if (item == "Competition Law") {
            this.state.Interest_Competition = true;
        }
        else if (item == "Corporate & Commercial Law") {
            this.state.Interest_Corporate = true;
        }
        else if (item == "Environmental & Energy Law") {
            this.state.Interest_Environmental = true;
        }
        else if (item == "European Union Law") {
            this.state.Interest_European = true;
        }
        else if (item == "Intellectual Property Law") {
            this.state.Interest_Intellectual = true;
        }
        else if (item == "Labor & Employment Law") {
            this.state.Interest_Labor = true;
        }
        else if (item == "Tax Law") {
            this.state.Interest_Tax = true;
        }
        else if (item == "Trade Law") {
            this.state.Interest_Trade = true;
        }
        else if (item == "Transport Law") {
            this.state.Interest_Transport = true;
        }
    }

    validateForm() {

        let fields = this.state.userDetails;
        let errors = {};
        let formIsValid = true;

        if (!fields["firstName"]) {
            formIsValid = false;
            errors["firstName"] = "* Required field";
        }
        else if (typeof fields["firstName"] !== "undefined") {
            if (!fields["firstName"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["firstName"] = "* Please enter alphabet characters only.";
            }
        }


        if (!fields["lastName"]) {
            formIsValid = false;
            errors["lastName"] = "* Required field";
        }
        else if (typeof fields["lastName"] !== "undefined") {
            if (!fields["lastName"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["lastName"] = "* Please enter alphabet characters only.";
            }
        }

        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "* Required field";
        }

        if (typeof fields["email"] !== "undefined") {
            //regular expression for email validation
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(fields["email"])) {
                formIsValid = false;
                errors["email"] = "* Please enter a valid email address";
            }
        }

        if (!fields["organization"]) {
            formIsValid = false;
            errors["organization"] = "* Required field";
        }
        else if (typeof fields["organization"] !== "undefined") {
            if (!fields["organization"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["organization"] = "*Please enter alphabet characters only.";
            }
        }

        if (!fields["jobTitle"]) {
            formIsValid = false;
            errors["jobTitle"] = "* Required field";
        }


        if (!fields["country"]) {
            formIsValid = false;
            errors["country"] = "* Required field";
        }

        if (!fields["iAgree"]) {
            formIsValid = false;
            errors["iAgree"] = "* Permission required to send message";
        }

        this.setState({
            errors: errors
        });


        return formIsValid;


    }

    submitEnquiry() {
        var self = this;
        var data = [];
        // console.log(this.state.userDetails);
        if (this.validateForm()) {

            var leadParameters = {
                Salutation: this.state.userDetails.salutation, FirstName: this.state.userDetails.firstName, LastName: this.state.userDetails.lastName, Email: this.state.userDetails.email, Phone: this.state.userDetails.phoneNumber, Country: this.state.userDetails.country, Organization: this.state.userDetails.organization, Title: this.state.userDetails.jobTitle, Product: this.state.practicearea, Description: this.state.selectedString, SubscriptionType: this.state.userDetails.subType, AdditionalInfo: this.state.userDetails.addInfo
            }
            //var params = { Company: "My test comp", LastName: "My test Last name" };
            //console.log(leadParameters);

            //Comment out below e-mail functionality code as discussed with Sandra, Now API is working fine.
            //if (this.state.userDetails.iAgree) {
            //    appService.submit('/Email/SendMarketingEmail', leadParameters)
            //        .then(function (data) {
            //            if (data == "") {

            //            }
            //        });
            //}

            var Parameters = {
                FirstName: this.state.userDetails.firstName, LastName: this.state.userDetails.lastName, Email: this.state.userDetails.email, Phone: this.state.userDetails.phoneNumber, Country: this.state.userDetails.country, Company: this.state.userDetails.organization, Title: this.state.userDetails.jobTitle, Publication__c: this.state.selectedString, Practice_area_KLO__c: this.state.practicearea, Event_of_interest__c: this.state.userDetails.subType, Description: this.state.userDetails.addInfo
            }

            var MailchimpParam = {

                email_address: this.state.userDetails.email,
                status: "subscribed",
                merge_fields: {
                    FNAME: this.state.userDetails.firstName,
                    LNAME: this.state.userDetails.lastName,
                    MMERGE3: this.state.userDetails.phoneNumber,
                    MMERGE6: this.state.userDetails.country,
                    COMPANY: this.state.userDetails.organization
                },
                interests: {
                    "2b95fb31ba": this.state.Interest_Arbitration,
                    "8b3e823a34": this.state.Interest_Comparative,
                    bb5d55e229: this.state.Interest_Competition,
                    c10c033846: this.state.Interest_Corporate,
                    ee4d74ee71: this.state.Interest_Environmental,
                    d51d3563fe: this.state.Interest_European,
                    "5e398bb8ff": this.state.Interest_Intellectual,
                    "0f50047a21": this.state.Interest_Labor,
                    "6092e266c1": this.state.Interest_Tax,
                    d87b1132c6: this.state.Interest_Trade,
                    "3e117bef8e": this.state.Interest_Transport
                }

            }

            //Email: this.state.userDetails.email, , Title: this.state.userDetails.jobTitle, Publication__c: this.state.selectedString, Practice_area_KLO__c: this.state.practicearea, Event_of_interest__c: this.state.userDetails.subType, Description: this.state.userDetails.addInfo

            //var Parameters = {
            //    FirstName: this.state.userDetails.firstName, LastName: this.state.userDetails.lastName, Email: this.state.userDetails.email, Phone: this.state.userDetails.phoneNumber,
            //    Country: this.state.userDetails.country, Company: this.state.userDetails.organization, Title: this.state.userDetails.jobTitle,
            //    Publication_c: this.state.selectedString, Practice: this.state.practicearea, Event_of_interest: this.state.userDetails.subType,
            //    Description: "Additinal Information"+":" + this.state.userDetails.addInfo + " " + "Publication"+":" + this.state.selectedString
            //}
            if (this.state.userDetails["intrestedInmkting"]) {
                userService.handleMailchimp(MailchimpParam)
                    .then(function (data) {
                        self.setState({ users: data });
                        //if (data == "User registered successfully") {
                        // self.setState({ redirectToThankyou: true });
                        //}
                    });
            }

            userService.leadHandle(Parameters)
                .then(function (data) {
                    self.setState({ users: data });
                    //if (data == "User registered successfully") {
                    // self.setState({ redirectToThankyou: true });
                    //}
                    window.location = "/ThankyouSubscription";
                });

            this.childList.current.ClearList();
            let fields = {};
            fields["firstName"] = "";
            fields["lastName"] = "";
            fields["email"] = "";
            fields["phoneNumber"] = "";
            this.setState({ fields: fields });
            this.setState({ ShowError: false });
        }

    }


    handleEmailChange(e) {
        const email = e.target.value
        const emailValid = this.validateEmail(email)

        this.setState({
            email: e.target.value,
            valid: emailValid
        })
    }

    componentDidMount() {

        var self = this;
        appService.getByName('appdata/GetAppData?fieldName=ContactSales')
            .then(function (data) {

                self.setState({ content: data });
            });

        appService.getAll('Cart/GetAllCountries').then(function (response) {
            self.setState({
                countries: response
            });

        })

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Contact sales");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }


    render() {
        let fieldContainerClass = 'field-container'
        const { email, valid } = this.state
        const { userDetails, submitted } = this.state;

        //if (this.state.redirectToThankyou) {
        //    return <Redirect to={"/ThankyouSubscription"} />
        //}

        if (!valid) {
            fieldContainerClass += ' error'
        }


        const meta = {
            title: "Kluwer Law Online - Contact sales",
            canonical: window.location.href,
        }
        return (
            <DocumentMeta {...meta}>
                <div className="col-12 klo-shopping-cart">
                    <div className="row">
                        <div className="col-lg-12 colPadding margintop">
                            <div className="mt-4 font-500">
                                <p className="franziskafont">Contact our sales team</p>
                                <p>
                                    <div className="BookBody">
                                        Call us at +31 (0) 172 641562 or complete and submit the details below and we will contact you to discuss your requirements and pricing options.
                                </div>

                                </p>
                                <p className="PublicationTitle green-heading">Please tell us a little bit about what you are interested in:</p>

                                <div className="row">
                                    <div className="col mr-4">

                                        <List SalesCallback={this.updateCount.bind(this)} SalesCallbackPA={this.GetPA.bind(this)} ref={this.childList} />
                                    </div>

                                    <div className="col ml-3">
                                        <form>
                                            <h6 className="my-3">Type of subscription</h6>
                                            <br></br>
                                            <div className="form-group">
                                                <input type="radio"
                                                    value="Subscription request"
                                                    checked={this.state.selectedOption === "Subscription request"}
                                                    onChange={this.radioChange} style={{ marginRight: '2%' }} />Subscription request
                                                </div>
                                            <div className="form-group">
                                                <input type="radio"
                                                    value="Print copy"
                                                    checked={this.state.selectedOption === "Print copy"}
                                                    onChange={this.radioChange} style={{ marginRight: '2%' }} />Print copy
                                                </div>
                                            <div className="form-group">
                                                <input type="radio"
                                                    value="demo request"
                                                    checked={this.state.selectedOption === "demo request"}
                                                    onChange={this.radioChange} style={{ marginRight: '2%' }} />Demo/trial request
                                          </div>
                                            <br></br>
                                        </form>
                                        <p> Additional information/requirements</p>
                                        <textarea onChange={this.valueChange}
                                            className="form-control"
                                            value={userDetails.addInfo}
                                            id="addInfo"
                                            name="addInfo"
                                            rows="5" placeholder="Enter your message (optional)"
                                        />

                                        <br></br>

                                    </div>
                                </div>
                                <hr className="mt-4 mb-3" />
                                <div className="row">
                                    <div className="col mr-4">
                                        <div className="form-row mt-3">
                                            <div className="col">
                                                <p className="PublicationTitle green-heading">Please tell us how we can reach you:</p>
                                            </div>
                                        </div>

                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="firstName">First name</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="firstName" name="firstName" value={userDetails.firstName} onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.firstName}</div>
                                            </div>
                                            <div className="col-lg-6">
                                                <label for="lastName">Last name</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" value={userDetails.lastName} onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.lastName}</div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <div>
                                                    <label for="email">Email address</label>
                                                    <input type='email' value={userDetails.email} onChange={this.valueChange} id="email" name="email" className="form-control form-control-sm rounded-0"
                                                    />
                                                    <div className="errorMsg">{this.state.errors.email}</div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <label for="phoneNumber">Phone number (optional)</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="phoneNumber" name="phoneNumber" value={userDetails.phoneNumber} onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.phoneNumber}</div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="organization">Organization</label>
                                                <input type="text" placeholder="Organization" className="form-control form-control-sm rounded-0" placeholder="" id="organization" name="organization" value={userDetails.organization} onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.organization}</div>
                                            </div>
                                            <div className="col-lg-6">
                                                <label for="jobTitle">Job title</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="jobTitle" name="jobTitle" value={userDetails.jobTitle} onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.jobTitle}</div>

                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="form-group mt-3">
                                            <label for="exampleFormControlSelect1">Country</label>
                                            <select className="form-control form-control-sm rounded-0" id="countryId" value={this.state.countryId} onChange={this.handleCountriesChange}>
                                                <option selected style={{ display: 'none' }}> </option>
                                                {
                                                    (this.state.countries && this.state.countries.length > 0) && this.state.countries.map((data) => {
                                                        return (<option value={data.country}> {data.country}</option>);
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="errorMsg">{this.state.errors.country}</div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="form-group">
                                                <div className="square"><input type="checkbox" id="mailchimp" onChange={this.handlemailchimpcheck} />
                                                    <label for="mailchimp"></label>
                                                    <span style={{ paddingLeft: '4%' }}>If you would like to receive information on relevant products and services from Kluwer Law International, please mark checked in checkbox.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group mt-3">
                                            <div className="form-group">
                                                <div className="square"><input type="checkbox" id="information" onChange={this.handlecheckChange} />
                                                    <label for="information"></label>
                                                    <span style={{ paddingLeft: '4%' }}>I agree to the storage of my email and name for the purpose of handling my inquiry. For further privacy details <a href="http://www.kluwerlaw.com/gdpr/" Tdata-tooltip="Personal data processing info" target="_blank">click here</a>.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="errorMsg">{this.state.errors.iAgree}</div>
                                        <br></br>

                                    </div>

                                    <div className="col ml-3"> </div>
                                </div>
                                <div className="row mb-5 mt-3 ">
                                    <div className="col">
                                        <button type="button" className="btn next float-left rounded-0" onClick={this.submitEnquiry} >Send message</button>
                                    </div>

                                </div>
                            </div>
                        </div> </div> </div>
            </DocumentMeta>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/ContactSalesNew.jsx